import React from 'react'

export default function ReservationImg() {
    return (
        <div className="col-xs-12 col-md-6 col-md-offset-6 side-image"
            data-background="assets/images/TimeBooking/4.png">
        </div>
    )
}
